import React from 'react';
import {
  Page,
  EditPageContainer,
  withServerErrors,
  withResolver,
} from 'components/common';
import {
  FormGroup,
  required,
  SaveButton,
  BackButton,
  DatePicker,
} from 'components/common/Forms';
import moment from 'moment';
import { compose, withState, withProps, withPropsOnChange, withHandlers } from 'recompose';
import { Control, actions, LocalForm, Errors, track } from 'react-redux-form';
import {
  Row,
  Col,
  Button,
  Card,
  CardBody,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Modal,
} from 'reactstrap';
import { Installer } from 'config/roles';
import Select from 'react-select';
import { NotificationManager } from 'react-notifications';
import { includes, get, find } from 'lodash';
import shortid from 'shortid';
import withLifecycle from '@hocs/with-lifecycle';
import {OrderImport} from "../../components/common/OrderImport";
import { nullBooleanDropdown  } from '../common';
const Aux = props => props.children;


export const Create = ({
  onChange,
  onUpdate,
  onSubmit,
  onSubmitFailed,
  setDispatch,
  item,
  onBack,
  dispatch,
  form,
  installationTypes,
  fuelTypes,
  jobTypes=  [
    {'value': 10, 'text': "New Installation"},
    {'value': 80, 'text': "New Installation + Remove Competitor Devices"},
    {'value': 20, 'text': "De-installation"},
    {'value': 30, 'text': "De-installation / Re-installation"},
    {'value': 40, 'text': "Service Call"}
  ],
  devices,
  voltages,
  additionalEquipment,
  jobStatuses,
  installers,
  whiteLabelPartners,
  readOnly,
  accepted,
  isInstaller,
  client,
  onChanged,
  isAssigning,
  setIsAssigning,
  isChangingStatus,
  setIsChangingStatus,
  rejectOrder,
  rejectModal,
  history,
  issuers,
  countries
}) => (
  <Page title="" className="container">
    <LocalForm
      onChange={onChange}
      onUpdate={onUpdate}
      onSubmit={onSubmit}
      onSubmitFailed={onSubmitFailed}
      getDispatch={setDispatch}
      initialState={item}
    >
      <Row>
        <Col>
          <h3> Customer Details </h3>
        </Col>
        <Col>
          <div>
            <OrderImport client={client} whiteLabelPartners={whiteLabelPartners} installers={installers} />
          </div>
        </Col>
      </Row>
      <hr />
      <Row>
        <Col>
          <FormGroup label="Company Name" model=".customerName">
            <Control.input
              updateOn="blur"
              readOnly={readOnly}
              model=".customerName"
              type="text"
              required
            />
          </FormGroup>
          <FormGroup label="Address Line 1" model=".addressLine1">
            <Control.input
              updateOn="blur"
              readOnly={readOnly}
              model=".addressLine1"
              type="text"
              required
              maxLength={100}
            />
          </FormGroup>
          <FormGroup label="Town/City" model=".townOrCity">
            <Control.input
              updateOn="blur"
              readOnly={readOnly}
              model=".townOrCity"
              type="text"
              required
            />
          </FormGroup>
          <FormGroup label="Postcode" model=".postCode">
            <Control.input
              updateOn="blur"
              readOnly={readOnly}
              model=".postCode"
              type="text"
            />
          </FormGroup>
          <FormGroup label="Contact Number" model=".contactTelNo">
            <Control.input
              updateOn="blur"
              readOnly={readOnly}
              model=".contactTelNo"
              type="text"
              required
            />
          </FormGroup>
        </Col>
        <Col>
          <FormGroup label="Contact Name" model=".contactName">
            <Control.input
              readOnly={readOnly}
              updateOn="blur"
              model=".contactName"
              type="text"
              required
            />
          </FormGroup>
          <FormGroup label="Address Line 2" model=".addressLine2">
            <Control.input
              readOnly={readOnly}
              updateOn="blur"
              model=".addressLine2"
              type="text"
              maxLength={100}
            />
          </FormGroup>
          <FormGroup label="County" model=".county">
            <Control.input
              readOnly={readOnly}
              updateOn="blur"
              model=".county"
              type="text"
            />
          </FormGroup>
          <FormGroup label="Country" model=".country">
            <Control.select 
              model=".country"
              required
              validators={{
                      requiredAndValid: (val) => countries.some(country => country.name === val),
                    }}
              >
              <option />
              {countries.map(i => (
                <option key={`country-${i.id}`} value={i.name}>
                  {i.name}
                </option>
              ))}
            </Control.select>
            <Errors
              model=".country"
              show="touched"
              messages={{
                requiredAndValid: `Please select a Country`,
              }}
              wrapper={props => (
                <span className="small text-danger form-text">
                  {props.children}
                </span>
              )}
            />
          </FormGroup>
          <FormGroup label="Contact Email" model=".contactEmailAddress">
            <Control.input
              updateOn="blur"
              readOnly={readOnly}
              model=".contactEmailAddress"
              type="email"
              required
            />
          </FormGroup>
        </Col>
      </Row>
      <FormGroup label="Dispatch Address (Show only when it’s different with install address)" model=".dispatchAddress">
        <Control.input
          updateOn="blur"
          readOnly={readOnly}
          model=".dispatchAddress"
          type="text"
        />
      </FormGroup>
      <hr/>
      <Row>
        <Col>
          <h3>Order Details</h3>
          <FormGroup label="Customer Email" model=".customerEmailAddress">
            <Control.input
              updateOn="blur"
              model=".customerEmailAddress"
              type="email"
              required
            />
          </FormGroup>
          <FormGroup label="Job Type" model=".jobType">
            <Control.select model=".jobType" required>
              <option />
              {jobTypes.map(i => (
                <option key={i.value} value={i.text}>
                  {i.text}
                </option>
              ))}
            </Control.select>
          </FormGroup>
          <FormGroup label="Service Desk Ticket Reference" model=".serviceDeskTicket">
            <Control.text
              disabled={readOnly}
              updateOn="blur"
              model=".serviceDeskTicket"
              maxLength={30}
              required={item.jobType == "Service Call"}
            />
          </FormGroup>
          {whiteLabelPartners && (
            <FormGroup label="White Label Partner" model=".whiteLabelPartner">
              <Control.select model=".whiteLabelPartner">
                <option />
                {whiteLabelPartners.map(i => (
                  <option key={i.id} value={i.id}>
                    {i.name}
                  </option>
                ))}
              </Control.select>
            </FormGroup>
          )}
          <FormGroup label="Sales Agent Email Address" model=".salesAgentEmail">
            <Control.input
              updateOn="blur"
              model=".salesAgentEmail"
              type="email"
            />
          </FormGroup>
          <FormGroup label="Courier Tracking Number" model=".courierTrackingNumber">
            <Control.input model=".courierTrackingNumber" type="text" />
          </FormGroup>
        </Col>
        <Col>
          <h3>&nbsp;</h3>
          <FormGroup label="Customer Number" model=".custNo">
            <Control.input
              model=".custNo"
              type="number"
              validators={{
                length: v => !v || v.toString().length <= 9,
                value: v => !v || v >= 0 ,
              }}
              required
            />
          </FormGroup>
          <FormGroup label="Customer Surrogate ID" model=".surrogateId">
            <Control.input model=".surrogateId" type="text" required/>
          </FormGroup>
          {installers && (
            <FormGroup label="Installer" model=".installer">
              <Control.select disabled={readOnly} model=".installer">
                <option />
                {installers.map(i => (
                  <option key={i.id} value={i.id}>
                    {i.name}
                  </option>
                ))}
              </Control.select>
            </FormGroup>
          )}
          {issuers && (
            <FormGroup label="Issuer" model=".issuer">
              <Control.select model=".issuerId">
                <option />
                {issuers.map(i => (
                  <option key={i.id} value={i.issuer_id}>
                    {i.description}
                  </option>
                ))}
              </Control.select>
            </FormGroup>
          )}
          <FormGroup label="Premium installation service" model=".premiumInstallation">
            <Control.select disabled={readOnly} model=".premiumInstallation">
              <option />
              {nullBooleanDropdown.map(i => (
                <option key={i.value} value={i.value}>
                  {i.text}
              </option>
              ))}
            </Control.select>
          </FormGroup>
          <FormGroup label="Project Order" model=".projectOrder">
            <Control.select disabled={readOnly} model=".projectOrder">
              <option />
              {nullBooleanDropdown.map(i => (
                <option key={i.value} value={i.value}>
                  {i.text}
              </option>
              ))}
            </Control.select>
          </FormGroup>
        </Col>
      </Row>
        <FormGroup label="Job Description" model=".notes">
          <Control.textarea
            disabled={readOnly}
            updateOn="blur"
            model=".notes"
            required={item.jobType == "Miscellaneous" || item.jobType == "Service Call"}
          />
        </FormGroup>
      <hr />
      {item.vehicleList ? item.vehicleList.map((job,i_job) =>
        <Row>
          <Col>
            <h4>Install Details</h4>
            <FormGroup label="Device Make & Model" model={ track('local.vehicleList[].deviceMakeModel',{ 'key':job.key }) }>
              <Control.input
                readOnly={readOnly}
                updateOn="blur"
                model={ track('local.vehicleList[].deviceMakeModel',{ 'key':job.key }) }
                type="text"
              />
            </FormGroup>
            <FormGroup label="Item Type & Quantity" model={ track('local.vehicleList[].supplementaryItemTypes',{ 'key':job.key }) }>
              <Control.textarea
                readOnly={readOnly}
                updateOn="blur"
                model={ track('local.vehicleList[].supplementaryItemTypes',{ 'key':job.key }) }
                type="text"
                validators={{
                  valid: v => !v | /^(.* X \d+\n?)+$/.test(v),
                }}
              />
              <Errors
                model={ track('local.vehicleList[].supplementaryItemTypes',{ 'key':job.key }) }
                messages={{
                  valid: `format shall be item X number. Ex: 2-HARNESS X 4`,
                }}
                wrapper={props => (
                  <span className="small text-danger form-text">
                    {props.children}
                  </span>
                )}
              />
              <span className="text-muted" style={{ fontSize: '12px', marginTop: '5px', display: 'block' }}>
                Example format:<br />
                Item X 1<br />
                Item X 2
              </span>
            </FormGroup>
            <FormGroup label="Installation Type" model={track('local.vehicleList[].installationTypeList[]',{'key':job.key})}>
              <Card className={readOnly ? 'disabled' : ''}>
                <CardBody>
                  {installationTypes.map(i => (
                    <FormGroup
                      check
                      label={i.display_name}
                      model={track('local.vehicleList[].installationTypeList[]',{'key':job.key})}
                      key={i.id}
                    >
                      <Control.checkbox
                        disabled={readOnly}
                        model={ track('local.vehicleList[].installationTypeList[]',{'key':job.key}) }
                        value={i.display_name}
                        changeAction={(model, value, ...props) => {
                          dispatch(actions.checkWithValue(model, value, ...props));
                          setTimeout(() => {
                            dispatch(actions.validate('local'));
                          }, 0);
                        }}
                      />
                    </FormGroup>
                  ))}
                  {includes(find(item.vehicleList,{'key':job.key}).installationTypeList, "Other") && (
                    <Control.input
                      readOnly={readOnly}
                      model={ track('local.vehicleList[].installationTypeOther',{'key':job.key}) }
                      updateOn="blur"
                      validators={{
                        required,
                      }}
                    />
                  )}
                </CardBody>
              </Card>
            </FormGroup>
            <FormGroup label="Additional Equipment" addControlClass={false}>
              <Control.select
                component={Select}
                placeholder="Additional Equipment"
                model={ track('local.vehicleList[].additionalEquipment',{'key':job.key}) }
                disabled={readOnly}
                options={additionalEquipment}
                multi
                labelKey="text"
                valueKey="text"
                isLoading={!additionalEquipment}
                changeAction={(model, value) => {
                  dispatch(actions.change(model, value.map(ae => ae.text)));
                }}
              />
            </FormGroup>
            <FormGroup label="Kit Dispatched Date">
              <DatePicker
                className="form-control"
                model=".kitDispatchedDate"
                disabled={readOnly}
                type="date"
                viewDateFormat="YYYY-MM-DD"
                modelDateFormat="YYYY-MM-DD"
                shouldCloseOnSelect={false}
              />
            </FormGroup>
            <FormGroup label="Installation Preference Dates" model=".preferredInstallDates">
              <Control.input 
                model=".preferredInstallDates" 
                type="text" 
                validators={{
                  valid: v => !v | /^(?:\d{4}-\d{2}-\d{2})(?:\s*,\s*\d{4}-\d{2}-\d{2}){0,2}$|^$/.test(v),
                }}
              />
              <Errors
                model=".preferredInstallDates"
                messages={{
                  valid: `format shall be YYYY-MM-DD and max 3 dates allowed`,
                }}
                wrapper={props => (
                  <span className="small text-danger form-text">
                    {props.children}
                  </span>
                )}
              />
              <span className="text-muted" style={{ fontSize: '12px', marginTop: '5px', display: 'block' }}>
                Example format: yyyy-mm-dd, yyyy-mm-dd, …<br />
                Max. 3 dates<br />
              </span>
            </FormGroup>
            <FormGroup label="Appointment Date">
              <DatePicker
                className="form-control"
                model={ track('local.vehicleList[].appointment_date',{'key':job.key}) }
                disabled={readOnly}
                type="date"
                viewDateFormat="YYYY-MM-DD"
                modelDateFormat="YYYY-MM-DD"
                minDate={moment()}
                maxDate={moment().add(90, 'days')}
                shouldCloseOnSelect={false}
              />
              <Errors
                model={ track('local.vehicleList[].appointment_date',{'key':job.key}) }
                messages={{
                  past: 'The Installation Date cannot be in the past',
                }}
                wrapper={props => (
                  <span className="small text-danger form-text">
                    {props.children}
                  </span>
                )}
              />
            </FormGroup>
            <FormGroup label="Job Completed Date">
              <DatePicker
                className="form-control"
                model={ track('local.vehicleList[].job_completed_at',{'key':job.key}) }
                disabled={readOnly}
                type="date"
                viewDateFormat="YYYY-MM-DD"
                modelDateFormat="YYYY-MM-DD"
                shouldCloseOnSelect={false}
              />
            </FormGroup>
          </Col>
          <Col>
            <h3>Device Details</h3>
            <FormGroup label='IMEI/Box ID' model={track('local.vehicleList[].imei',{'key':job.key})}>
              <Control.input
                readOnly={readOnly}
                model={track('local.vehicleList[].imei',{ 'key':job.key })}
                updateOn="blur"
                maxLength={30}
                validators={{
                  valid: v => !v || /[a-zA-Z0-9]{1,30}$/.test(v),
                }}
              />
              <Errors
                model={ track('local.vehicleList[].imei',{ 'key':job.key }) }
                messages={{
                  valid: 'IMEI must be <=30 digits',
                }}
                wrapper={props => (
                  <span className="small text-danger form-text">
                    {props.children}
                  </span>
                )}
              />
            </FormGroup>
            <FormGroup label="Serial No." model={ track('local.vehicleList[].serial_number',{ 'key':job.key }) }>
              <Control.input
                readOnly={readOnly}
                updateOn="blur"
                model={ track('local.vehicleList[].serial_number',{ 'key':job.key }) }
                type="text"
              />
            </FormGroup>
            <FormGroup label="Device Type" model={ track('local.vehicleList[].deviceType',{ 'key':job.key }) }>
              <Control.select
                disabled={readOnly}
                placeholder="Select"
                model={ track('local.vehicleList[].deviceType',{ 'key':job.key }) }
                required
              >
                {devices.map(i => (
                  <option key={i.id} value={i.display_name}>
                    {i.display_name}
                  </option>
                ))}
              </Control.select>
            </FormGroup>
          </Col>
          <Col>
            <div className="row">
              <h3>Vehicle Details</h3>
              <Button
                onClick={() => {
                  dispatch(actions.remove('local.vehicleList', i_job));
                }}
                className="ml-auto btn-danger p-2"
              >
                Remove Vehicle
              </Button>
            </div>
            <FormGroup label="Make" model={ track('local.vehicleList[].make',{ 'key':job.key }) }>
              <Control.input
                readOnly={readOnly}
                updateOn="blur"
                model={ track('local.vehicleList[].make',{ 'key':job.key }) }
                type="text"
                required
              />
            </FormGroup>
            <FormGroup label="Model" model={ track('local.vehicleList[].vehicle_model',{ 'key':job.key }) }>
              <Control.input
                readOnly={readOnly}
                updateOn="blur"
                model={ track('local.vehicleList[].vehicle_model',{ 'key':job.key }) }
                type="text"
                required
              />
            </FormGroup>
            <FormGroup label="Year of Manufacture" model={ track('local.vehicleList[].yearOfManufacture',{ 'key':job.key }) }>
              <Control.input
                readOnly={readOnly}
                updateOn="blur"
                model={ track('local.vehicleList[].yearOfManufacture',{ 'key':job.key }) }
                type="number"
                validators={{
                  length: v => !v || v.toString().length === 4,
                  value: v => !v || v >= 1900 && v <= moment().year() + 1,
                }}
                changeAction={(model, value) => {
                  dispatch(actions.change(model, value === '' ? null : value));
                }}
              />
              <Errors
                model={ track('local.vehicleList[].yearOfManufacture',{ 'key':job.key }) }
                messages={{
                  length: 'Must be a 4-digit year e.g. 1999',
                  value: `Year must be between 1900 and ${moment().year() + 1}`,
                }}
                wrapper={props =>
                  props.children.map(c => (
                    <span className="small text-danger form-text">{c}</span>
                  ))
                }
              />
            </FormGroup>
            <FormGroup label="Vehicle Registration" model={ track('local.vehicleList[].registration',{ 'key':job.key }) }>
              <Control.input
                readOnly={readOnly}
                updateOn="blur"
                model={ track('local.vehicleList[].registration',{ 'key':job.key }) }
                type="text"
                required
              />
            </FormGroup>
            <FormGroup label="Fuel Type" model={ track('local.vehicleList[].fuelTypeCode',{ 'key':job.key }) }>
              <Control.select
                disabled={readOnly}
                model={ track('local.vehicleList[].fuelTypeCode',{ 'key':job.key }) }
              >
                {fuelTypes.map(i => (
                  <option key={i.value} value={i.value}>
                    {i.text}
                  </option>
                ))}
              </Control.select>
            </FormGroup>
            <FormGroup label="Voltage" model={track('local.vehicleList[].voltage',{ 'key':job.key })} addControlClass={false}>
              <Control.select
                component={Select}
                placeholder="Unknown"
                model={ track('local.vehicleList[].voltage',{ 'key':job.key }) }
                disabled={readOnly}
                options={voltages}
                clearable
                labelKey="text"
                valueKey="id"
                isLoading={!voltages}
              />
            </FormGroup>
          </Col>
        </Row>
      ) : ''}
      <div className='d-flex m-3'>
        <Button
          onClick={() => {
            dispatch(actions.push('local.vehicleList', {'key': shortid(),'deviceType': 'OBD'}))
          }}
          className="ml-auto p-2"
        >
          Add Vehicle
        </Button>
      </div>

      <div className="clear-fix">
        {!readOnly && (
          <SaveButton disabled={false} form={form} className="float-right" />
        )}
        <BackButton className="float-left" onClick={onBack} />
      </div>
    </LocalForm>
  </Page>
);

const emptyPromise = Promise.resolve({ data: null });

const enhance = compose(
  withProps(({ role }) => ({ isInstaller: role === Installer })),
  withState('installationTypes', 'setInstallationTypes', []),
  withState('fuelTypes', 'setFuelTypes', []),
  withState('jobStatuses', 'setJobStatuses', []),
  withState('devices', 'setDevices', []),
  withState('voltages', 'setVoltages', []),
  withState('additionalEquipment', 'setAdditionalEquipment', []),
  withState('installers', 'setInstallers', []),
  withState('whiteLabelPartners','setWhiteLabelPartners',[]),
  withState('isAssigning', 'setIsAssigning'),
  withState('isChangingStatus', 'setIsChangingStatus'),
  withState('activeTab', 'setActiveTab', 0),
  withState('rejectModal', 'setRejectModal', false),
  withState('item', 'setItem', false),
  withState('issuers', 'setIssuers', []),
  withState('countries','setCountries',[]),
  EditPageContainer({
    url: 'import_order',
    saveErrorHandler: ({ setServerErrors }) => err => {
      const data = get(err, 'response.data');
      if (data) {
        return NotificationManager.error(
          data.message,
        );
      }
    },
    saveSuccessHandler: ({history}) => resp => {
      const id = get(resp, 'data.data.firstJob');
      history.push('/manage-job/' + id);
    }
  }),
  withResolver(
    {
      options: () => client =>
        client.get(
          'options?installation_types&fuel_types&job_types&devices&additional_equipment&voltages'
        ),
      // installationTypes: () => client => client.get('installation_types'),
      //fuelTypes: () => client => client.get('fuel_types'),
      // jobTypes: () => client => client.get('job_types'),
      //devices: () => client => client.get('devices'),
      // additionalEquipment: () => client => client.get('additional_equipment'),
      installers: ({ isInstaller }) => client =>
        !isInstaller ? client.get('installers') : emptyPromise,
      jobStatuses: () => client => client.get('job_statuses'),
      whiteLabelPartners: () => client => client.get('white-label-partners'),
      issuers: () => client => client.get('issuers'),
      countries: () => client => client.get('countries'),
    },
    {
      onResolved: ({
        setInstallationTypes,
        setFuelTypes,
        setJobTypes,
        setJobStatuses,
        setDevices,
        setVoltages,
        setAdditionalEquipment,
        setInstallers,
        setWhiteLabelPartners,
        setIssuers,
        setCountries,
      }) => ({
        options: {
          installation_types: installationTypes,
          fuel_types: fuelTypes,
          devices,
          voltages,
          additional_equipment: additionalEquipment,
        },
        installers,
        whiteLabelPartners,
        jobStatuses,
        issuers,
        countries,
      }) => {
        setInstallationTypes(installationTypes);
        setFuelTypes(fuelTypes);
        setJobStatuses(jobStatuses);
        setDevices(devices);
        setVoltages(voltages);
        setAdditionalEquipment(additionalEquipment);
        setInstallers(installers);
        setWhiteLabelPartners(whiteLabelPartners);
        setIssuers(issuers);
        setCountries(countries);
      },
    }
  ),
  withHandlers({
    onChanged: ({ merge, setIsAssigning, setIsChangingStatus }) => value => {
      merge(value);
      setIsAssigning(false);
      setIsChangingStatus(false);
    },
    beforeSubmit: a => b => {
      return b;
    },
    rejectOrder: ({ setRejectModal, rejectModal }) => () => {
      setRejectModal(!rejectModal);
    },
    onSubmitFailed: () => form => {
      if (!form.$form.valid) {
        return NotificationManager.error(
          'Please check the form and try again.',
          'Data Invalid',
          10000
        );
      }
      return NotificationManager.error('An unexpected error occured');
    },
  }),
);

export default enhance(Create);



// WEBPACK FOOTER //
// ./src/pages/Orders/Create.jsx